<div>
	<div class="row align-items-center">
		<div class="col-md-6">
			<app-fast-filters
				#fastFilter
				[placeholder]="'Szybkie filtry'"
				[options]="fastFilters"
				(optionChanged)="selectFastFilter($event)"
			></app-fast-filters>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<div class="fill-width">
				<mat-form-field class="w-100 pe-2">
					<mat-label>Wybierz termin od</mat-label>
					<input
						matInput
						name="parseFilters.term__gte"
						[(ngModel)]="parseFilters.term__gte"
						[matDatepicker]="term__gte"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="term__gte"></mat-datepicker-toggle>
					<mat-datepicker #term__gte> </mat-datepicker>
				</mat-form-field>
				<mat-form-field class="w-100 ps-2">
					<mat-label>Wybierz termin do</mat-label>
					<input
						matInput
						name="parseFilters.term__lte"
						[(ngModel)]="parseFilters.term__lte"
						[matDatepicker]="term__lte"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="term__lte"></mat-datepicker-toggle>
					<mat-datepicker #term__lte> </mat-datepicker>
				</mat-form-field>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.reservation_seller"
				[(ngModel)]="filters.reservation_seller"
				[multiple]="true"
				placeholder="Agent"
			>
				<ng-option *ngFor="let item of agencies" [value]="item.id">{{ item.shortName }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<mat-form-field class="w-100">
				<mat-label>Numer rezerwacji</mat-label>
				<input matInput [(ngModel)]="filters.table_id__in" placeholder="Numer rezerwacji" />
			</mat-form-field>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<div class="text-xs leading-4 custom-text-color">Start pobytu</div>
			<div class="fill-width">
				<mat-form-field class="w-100 pe-2">
					<mat-label>Zakres od</mat-label>
					<input
						matInput
						name="parseFilters.reservation_stay_time_lower_after"
						[(ngModel)]="parseFilters.reservation_stay_time_lower_after"
						[matDatepicker]="reservation_stay_time_lower_after"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="reservation_stay_time_lower_after"></mat-datepicker-toggle>
					<mat-datepicker #reservation_stay_time_lower_after> </mat-datepicker>
				</mat-form-field>
				<mat-form-field class="w-100 ps-2">
					<mat-label>Zakres do</mat-label>
					<input
						matInput
						name="parseFilters.reservation_stay_time_lower_before"
						[(ngModel)]="parseFilters.reservation_stay_time_lower_before"
						[matDatepicker]="reservation_stay_time_lower_before"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="reservation_stay_time_lower_before"></mat-datepicker-toggle>
					<mat-datepicker #reservation_stay_time_lower_before> </mat-datepicker>
				</mat-form-field>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.reservation_seller"
				[(ngModel)]="filters.reservation_organization"
				[multiple]="true"
				placeholder="Organizator"
			>
				<ng-option *ngFor="let item of organizations" [value]="item.id">{{ item.shortName }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="parseFilters.reservation_status"
				[(ngModel)]="parseFilters.reservation_status"
				[multiple]="true"
				placeholder="Status rezerwacji"
			>
				<ng-option *ngFor="let item of reservationStatus" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<div class="text-xs leading-4 custom-text-color">Koniec pobytu</div>
			<div class="fill-width">
				<mat-form-field class="w-100 pe-2">
					<mat-label>Zakres od</mat-label>
					<input
						matInput
						name="parseFilters.reservation_stay_time_upper_after"
						[(ngModel)]="parseFilters.reservation_stay_time_upper_after"
						[matDatepicker]="reservation_stay_time_upper_after"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="reservation_stay_time_upper_after"></mat-datepicker-toggle>
					<mat-datepicker #reservation_stay_time_upper_after> </mat-datepicker>
				</mat-form-field>
				<mat-form-field class="w-100 ps-2">
					<mat-label>Zakres do</mat-label>
					<input
						matInput
						name="parseFilters.reservation_stay_time_upper_before"
						[(ngModel)]="parseFilters.reservation_stay_time_upper_before"
						[matDatepicker]="reservation_stay_time_upper_before"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="reservation_stay_time_upper_before"></mat-datepicker-toggle>
					<mat-datepicker #reservation_stay_time_upper_before> </mat-datepicker>
				</mat-form-field>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.count_kind"
				[(ngModel)]="filters.count_kind"
				[multiple]="false"
				placeholder="Sposób liczenia"
			>
				<ng-option *ngFor="let item of countKind" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				placeholder="Typ rezerwacji"
				name="seller_is_oskar"
				[(ngModel)]="filters.seller_is_oskar"
			>
				<ng-option [value]="Seller.IS_NOT_OSKAR">Agencyjna</ng-option>
				<ng-option [value]="Seller.IS_OSKAR">Nieagencyjna</ng-option>
				<ng-option [value]="Seller.ALL">Wszystkie</ng-option>
			</ng-select>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<div class="fill-width">
				<mat-form-field class="w-100 pe-2">
					<mat-label>Kwota</mat-label>
					<input matInput type="number" [(ngModel)]="parseFilters.value__gte" placeholder="Kwota" />
				</mat-form-field>
				<mat-form-field class="w-100 ps-2">
					<mat-label>Kwota</mat-label>
					<input matInput type="number" [(ngModel)]="parseFilters.value__lt" placeholder="Kwota" />
				</mat-form-field>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.status__in"
				[(ngModel)]="filters.status__in"
				[multiple]="true"
				placeholder="Status"
			>
				<ng-option *ngFor="let item of status" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="offer_product"
				[(ngModel)]="filters.offer_product"
				[multiple]="true"
				placeholder="Produkt"
			>
				<ng-option *ngFor="let item of products" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.currency__in"
				[(ngModel)]="filters.currency__in"
				[multiple]="true"
				placeholder="Waluta"
			>
				<ng-option *ngFor="let item of currency" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-8">
			<div class="text-end mt-3">
				<div class="col align-self-end">
					<button
						class="me-2 mat-button-save-filters"
						mat-raised-button
						color="primary"
						(click)="filtersSave()"
					>
						Pokaż
					</button>
					<button mat-raised-button class="mat-button-clear-all" (click)="filtersClear()">Wyczyść</button>
				</div>
			</div>
		</div>
	</div>
</div>
